function screamingSnakeCaseToKebabCase(str) {
    // replace all underscores with hyphens
    const hyphenated = str.replace(/_/g, "-");

    // convert to lowercase
    return hyphenated.toLowerCase();
}

const $error = {
    // 유효성 체크 폼 초기화
    clearForm(className) {
        const elements = document.getElementsByClassName(className);

        for (const element of elements) {
            element.innerHTML = "";
            this.removeElementAttributes(element, ["aria-invalid", "role"]);
        }
    },
    removeElementAttributes(element, attributes) {
        for (const attribute of attributes) {
            element.removeAttribute(attribute);
        }
    },
    // 에러 메세지 표시
    showMessage(response, self, refsId) {
        const { status, data: { errors } } = response;
        const errorStatuses = [400, 412, 500];

        if (!errorStatuses.includes(status)) {
            return;
        }

        errors.forEach(e => {
            const targetElement = refsId ? self.$refs[refsId] : self.$refs[e.code] || self.$refs["ERRORS"];
            targetElement.innerHTML = e.msg;
            this.setElementAttributes(targetElement, { "aria-invalid": "true", "role": "alert" });
        });
    },
    setElementAttributes(element, attributes) {
        for (const [key, value] of Object.entries(attributes)) {
            element.setAttribute(key, value);
        }
    },
    /**
     * 에러코드로 element id 를 찾고, 이를 포커싱한다.
     * 일반적으로 에러코드(SCREAMING_SNAKE_CASE), element id(kebab-case)
     * @param response
     */
    focus(response) {
        const { status, data: { errors } } = response;
        const errorStatuses = [400, 412, 500];

        if (!errorStatuses.includes(status)) {
            return;
        }

        const elementId = screamingSnakeCaseToKebabCase(errors[0]?.code);
        const element = document.getElementById(elementId);
        element?.focus();
    },
}

export {
    $error
}
